var packageName = "@atlassian/notification-list" || '@atlassian/notification-list';
var packageVersion = "10.5.0" || 'v9.9.9';
export { packageName, packageVersion };